<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('animal.Arrival') }}</h5>
    <p class="mb-0 text-sm">{{ $t('animal.Optional_information') }}</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">          
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Date') }}</label>
              <input v-model="localFormData.arrivalDate" type="date" class="form-control form-control-default" :placeholder="$t('animal.Date')"> 
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.UBN') }}</label>
              <input v-model="localFormData.arrivalFromUBN" type="text" class="form-control form-control-default" :placeholder="$t('animal.UBN')">             
            </div>
          </div>
      </div>
      <div class="row mt-3">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Origin') }}</label>  
              <select id="originId" v-model="localFormData.originId" class="form-control form-control-default">
                  <option value="">{{ $t('animal.Select_origin') }}</option>         
                  <option v-for="item in formData.origins" :key="item.id" :value="item.id">                  
                      {{ item.description }}
                  </option>
              </select>              
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Country') }}</label>  
              <select id="countryCodeId" v-model="localFormData.countryCodeId" class="form-control form-control-default">
                  <option value="">{{ $t('animal.Select_country') }}</option>
                  <option v-for="item in countryCodes" :key="item.id" :value="item.id">
                      {{ item.name }}
                  </option>
              </select>
            </div>
          </div>      
      </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="this.$parent.prevStep">{{ $t('common.Prev') }}</button>
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>                
      </div>
    </div>
  </div>
</template>
<script>
  import { reactive, watch } from 'vue'

  export default {
    name: "ArrivalSection",
    props: {
      countryCodes: Array,
      origins: Array,
      formData: Object,
      prevStep: Function,
      nextStep: Function
    },
    setup(props, { emit }) {
      const localFormData = reactive({ ...props.formData })
      
      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      const validateAndNextStep = async () => {
          props.nextStep()
      }

      return {
        localFormData,
        validateAndNextStep
      }
    }    
};
</script>